import React from "react";
import styled from "styled-components";
const InfoContainer = styled.p(
  ({ theme }) => `
  font-size: ${theme.fonts.size.small};
  color: ${theme.colors.text.secondary};
`
);
const SaveContextInfo = () => /* @__PURE__ */ React.createElement(InfoContainer, null, "The content you added won\u2019t be saved unless you click Save in your dashboard or search.");
export default SaveContextInfo;
